import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content-wrapper">
        <h1 className="privacy-heading">Privacy Policy</h1>
        <p className="privacy-updated">Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long' })}</p>

        <p className="privacy-text">
          PointeSense (&ldquo;we,&rdquo; &ldquo;us&rdquo;) is a startup building smart pressure-sensing
          technology for pointe shoes. This page explains what information we collect through this
          website and how we use it. We&rsquo;ll update this page as our product and data practices
          grow, but here&rsquo;s where things stand today.
        </p>

        <h2 className="privacy-subheading">Information We Collect</h2>
        <p className="privacy-text">
          When you fill out a form on this site, such as our early access list, beta-testing interest
          form, mailing list signup, or &ldquo;join the team&rdquo; email, we collect what you enter:
          typically your name, email address, role or affiliation, and any message you include. These
          forms are handled through Formspree, a third-party form processor, which relays submissions
          to us by email.
        </p>
        <p className="privacy-text">
          If you participate in beta testing, we may collect additional data with your explicit,
          separate consent, such as anatomical foot measurements, approximate weight, dance
          experience, and raw sensor data. This data collection is described in detail on our{' '}
          <a href="/beta-testing">Beta Testing</a> page and always requires a signed consent form
          before collection or use.
        </p>
        <p className="privacy-text">
          We also use Vercel Web Vitals to measure basic site performance (like page load speed).
          This does not include personally identifying information beyond the page you visited and a
          general connection speed indicator.
        </p>

        <h2 className="privacy-subheading">How We Use It</h2>
        <ul className="privacy-list">
          <li>To respond to your inquiries and manage early access, beta testing, or hiring interest</li>
          <li>To send product updates, research notes, or newsletter content, only if you&rsquo;ve opted in</li>
          <li>To guide product development, including training models on beta-testing data collected with consent</li>
          <li>To monitor and improve site performance</li>
        </ul>

        <h2 className="privacy-subheading">Data Sharing</h2>
        <p className="privacy-text">
          We share form submissions with Formspree (our form processor) and, where applicable, use
          Vercel for hosting and analytics. We do not share your personally identifying information,
          such as your name, contact details, or raw individual sensor readings, with pointe shoe
          manufacturers, research institutions, or other third parties without your consent.
        </p>
        <p className="privacy-text">
          As part of our product, we may share aggregated, anonymized, or averaged data (for example,
          trends across many dancers or shoe models, not identifiable to any one person) with brand
          or research partners to support their product or research goals. This is separate from, and
          does not include, your individually identifiable information.
        </p>

        <h2 className="privacy-subheading">Your Choices</h2>
        <p className="privacy-text">
          You can unsubscribe from newsletter emails at any time using the link in those emails, or by
          emailing us directly. You can also request that we delete information you&rsquo;ve submitted
          to us by contacting us at{' '}
          <a href="mailto:hello@pointesense.com">hello@pointesense.com</a>.
        </p>

        <h2 className="privacy-subheading">Contact</h2>
        <p className="privacy-text">
          Questions about this policy or your data? Reach out at{' '}
          <a href="mailto:hello@pointesense.com">hello@pointesense.com</a>.
        </p>
      </div>
    </div>
  );
};

export default Privacy;
